/** Step → route name, walking the nested route structure; the first route naming a step wins */
export function buildStepRouteMap(routes) {
    return mapStepRoutes(routes, (meta) => meta?.authSteps ?? []);
}
/** The same for the post-login steps (meta.postLoginStep); keyed by the session's step, which the UI may not know */
export function buildPostLoginRouteMap(routes) {
    return mapStepRoutes(routes, (meta) => (meta?.postLoginStep ? [meta.postLoginStep] : []));
}
export function isAuthScreen(route) {
    return route.matched.some((record) => record.meta.authScreen === true);
}
/** The screen already shows this step, so a result for it stays on the screen */
export function showsStep(route, step) {
    return route.matched.some((record) => (record.meta.authSteps ?? []).includes(step));
}
/** The route of the first open post-login step (strict order: only the first shows); undefined when none is open */
export function firstOpenStepRoute(session, routes) {
    const step = session?.postLoginSteps?.[0]?.step;
    if (!step)
        return undefined;
    // a step the UI has no route for can't be shown, so it doesn't lock the user out of the app
    const name = routes.get(step);
    if (!name)
        console.warn(`Unknown post-login step "${step}", opening the app without it`);
    return name;
}
/**
 * The post-login gate (the router guard), null when the route opens:
 * while a step is open, a route outside the step's route and its children goes to the step, keeping the target as fromUrl (the logout always opens),
 * with none open, a step route goes to the app's start.
 */
export function postLoginRedirect(to, stepRoute, logoutRoute) {
    if (!stepRoute)
        return to.matched.some((record) => record.meta.postLoginStep) ? '/' : null;
    if (to.name === logoutRoute || to.matched.some((record) => record.name === stepRoute))
        return null;
    return { name: stepRoute, query: { fromUrl: to.fullPath } };
}
/** Step → route name; the first route naming a step wins */
function mapStepRoutes(routes, stepsOf) {
    const map = new Map();
    const visit = (records) => {
        for (const record of records) {
            for (const step of stepsOf(record.meta)) {
                if (!map.has(step) && typeof record.name === 'string')
                    map.set(step, record.name);
            }
            if (record.children)
                visit(record.children);
        }
    };
    visit(routes);
    return map;
}
